package fr.manyverse.app.presentation.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import manyverse.shared.generated.resources.LibreBaskerville
import manyverse.shared.generated.resources.Res
import org.jetbrains.compose.resources.Font

/**
 * App-wide [Typography] built on top of the Material 3 defaults, swapping the font
 * family for Libre Baskerville. Keeps every default size/weight/line-height so the
 * Material type scale stays consistent — only the typeface changes.
 */
@Composable
fun manyverseTypography(): Typography {
    val libreBaskerville = FontFamily(Font(Res.font.LibreBaskerville))
    val default = Typography()

    return default.copy(
        displayLarge = default.displayLarge.copy(fontFamily = libreBaskerville),
        displayMedium = default.displayMedium.copy(fontFamily = libreBaskerville),
        displaySmall = default.displaySmall.copy(fontFamily = libreBaskerville),
        headlineLarge = default.headlineLarge.copy(fontFamily = libreBaskerville),
        headlineMedium = default.headlineMedium.copy(fontFamily = libreBaskerville),
        headlineSmall = default.headlineSmall.copy(fontFamily = libreBaskerville),
        titleLarge = default.titleLarge.copy(fontFamily = libreBaskerville),
        titleMedium = default.titleMedium.copy(fontFamily = libreBaskerville),
        titleSmall = default.titleSmall.copy(fontFamily = libreBaskerville),
        bodyLarge = default.bodyLarge.copy(fontFamily = libreBaskerville),
        bodyMedium = default.bodyMedium.copy(fontFamily = libreBaskerville),
        bodySmall = default.bodySmall.copy(fontFamily = libreBaskerville),
        labelLarge = default.labelLarge.copy(fontFamily = libreBaskerville),
        labelMedium = default.labelMedium.copy(fontFamily = libreBaskerville),
        labelSmall = default.labelSmall.copy(fontFamily = libreBaskerville),
    )
}
